<template>

  <div class="height-100">
    
    <creating
      v-if="creating"
      height="100%" />

      <div
        class="vflex"
        v-if="!creating">
    
        <div class="vflex-row-0 vflex-header">
          <div class="p-3">
            <div class="page-title">
              <div class="title">
                <h5>
                  <point-status :status="requisition.status"></point-status>
                  {{ requisition.title }}
                  <small>#{{ requisition.code }}</small>
                </h5>
                <h6>
                  <strong :class="requisition.status === 'analyzing' ? 'text-warning' : 'text-secondary'">{{ statusName }}</strong> - 
                  {{ requisition.hiring_manager_name }},
                  <span v-if="requisition.departament_id">{{ requisition.departament_id.name }},</span>
                  <span v-if="requisition.company_id">{{ requisition.company_id.name }},</span>
                  {{ $tc('n_openings', requisition.openings, {count: requisition.openings}) }} - 
                  {{ $d(new Date(requisition.created_at), 'short') }}
                </h6>
              </div>
              <div
                :class="{'box-loading': loading}"
                class="btn-row">

                <RequisitionFollow />

                <router-link
                  v-if="requisition.job"
                  class="btn btn-outline-secondary"
                  :to="{path: '/job/' + requisition.job._id}">
                  Acessar vaga
                  </router-link>

                <button
                  v-if="!requisition.job && permissions.includes('manage_jobs')"
                  class="btn btn-primary"
                  @click="openJob()">{{ $t('Create job') }}</button>

                <!-- Split dropup button -->
                <div
                  v-if="permissions.includes('manage_requisitions')"
                  class="btn-group">
                  <button
                    type="button"
                    @click="showEditModal(requisition)"
                    :disabled="lockStatus"
                    v-tooltip="{'pending': 'Requisição em processo de aprovação', 'approved': 'Requisição aprovada'}[lockStatus]"
                    class="btn btn-light">{{ $t('Edit') }}</button>
                  <button
                    type="button"
                    class="btn btn-light dropdown-toggle dropdown-toggle-split"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <span class="sr-only">Toggle Dropdown</span>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button
                      class="dropdown-item"
                      @click="clone()">{{ $t('Clone') }}</button>
                    <button
                      class="dropdown-item"
                      @click="analyzing"
                      v-if="requisition.status !== 'analyzing'">Analisar</button>
                    <button
                      class="dropdown-item"
                      @click="archived"
                      v-if="requisition.status !== 'archived'">{{ $t('Archive') }}</button>
                    <button
                      class="dropdown-item"
                      @click="deleteRequisition">{{ $t('Remove') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          
        </div>

        <div
          class="vflex-row-1 p-3">
          
          <div style="overflow: hidden;">
            <div class="row">
              <div class="col-sm-7">
                <RequisitionProfile
                  :requisition="requisition" />
              </div>
              <div class="col-sm-5">
                <RequisitionApprovalflow />
              </div>
            </div>
          </div>

        </div>

        <div
          v-if="modal_select"
          class="vflex-row-0">
          <requisition-form 
            :initRequisition="modal_select" 
            @hideModal="hideModal()" 
            @deleted="deleted" 
            @saved="hideModal()">
            </requisition-form>
        </div>

      </div>

  </div>

</template>

<script>
import RequisitionForm from '@/components/RequisitionForm/RequisitionForm'
import PointStatus from '@/components/Parts/PointStatus'
import RequisitionApprovalflow from './RequisitionApprovalflow'
import RequisitionProfile from './RequisitionProfile'
import RequisitionFollow from './RequisitionFollow'

export default {
  name: 'RequisitionRequisition',
  components: {
    RequisitionForm,
    PointStatus,
    RequisitionApprovalflow,
    RequisitionProfile,
    RequisitionFollow
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    requisitionId () {
      return this.$route.params.id
    },
    requisition () {
      return this.$store.getters.getRequisition
    },
    lockStatus () {
      const approvalflow = this.requisition.approvalflow
      if (approvalflow && ['pending', 'approved'].includes(approvalflow.status)) {
        return approvalflow.status
      }
      return null
    },
    statusName () {
      return {
        analyzing: 'Analisando',
        archived: this.$t('Archived')
      }[this.requisition.status]
    }
  },
  metaInfo () {
    return {
      title: this.creating ? 'Carregando...' : this.requisition.title
    }
  },
  watch: {
    requisitionId (value) {
      this.creating = true
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true
      this.$store
      .dispatch('selectRequisition', this.requisitionId)
      .then(() => {
        this.creating = this.loading = false
      })
    },
    /*
    openJob
    */
    openJob () {
      this.loading = true
      this.$store.dispatch('createJobFromRequisition', {
        requisition_id: this.requisition._id
      })
      .then((result) => {
        this.$router.push('/job/' + result._id)
      })
    },
    /*
    open
    */
    analyzing () {
      this.loading = true
      this.$store.dispatch('updateRequisitionAnalyze', {
        _id: this.requisition._id,
        status: 'analyze'
      }).then(() => {
        this.loading = false
      })
    },
    /*
    archived
    */
    archived () {
      this.loading = true
      this.$store.dispatch('updateRequisitionArchive', {
        _id: this.requisition._id,
        status: 'archive'
      }).then(() => {
        this.loading = false
      })
    },
    /*
    showEditModal
    */
    showEditModal (item) {
      this.modal_select = item
    },
    /*
    hideModal
    */
    hideModal () {
      this.modal_select = false
    },
    /*
    deleted
    */
    deleted () {
      this.$router.push('/requisitions')
    },
    /*
    clone
    */
    clone () {
      this.loading = true
      this.$store
      .dispatch('cloneRequisition', this.requisition._id)
      .then((result) => {
        this.$router.push('/requisition/' + result._id)
      })
    },
    /*
    deleteRequisition
    */
    deleteRequisition () {
      const deleteAction = () => {
        this.loading = true
        this.$store
        .dispatch('deleteRequisition', this.requisition._id)
        .then((result) => {
          this.$router.push('/requisitions')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Requisition/Requisition.vue